import {
  SESSION_COOKIE_CURRENT_TENANT,
  SESSION_COOKIE_NAME,
  SESSION_COOKIE_SIGNED_TOKEN,
  SESSION_COOKIE_USER
} from '~/core/constants/cookies'

type CookieMap = Partial<Record<string, string>>

/**
 * Parse Internal user cookie and require a usable user id.
 * Treats missing/"undefined"/"null"/invalid JSON/empty object as invalid.
 */
export function parseInternalUserCookie(
  userCookie?: string
): { id: string | number; onboarding?: boolean } | null {
  if (!userCookie || userCookie === 'undefined' || userCookie === 'null') {
    return null
  }

  try {
    const user = JSON.parse(userCookie) as {
      id?: string | number | null
      onboarding?: boolean
    } | null
    if (!user || typeof user !== 'object' || user.id == null || user.id === '') {
      return null
    }
    return { id: user.id, onboarding: user.onboarding }
  } catch {
    return null
  }
}

/**
 * Complete session = session token + signed token + parsable user with id.
 */
export function hasCompleteInternalSession(cookies: CookieMap): boolean {
  const sessionCookie = cookies[SESSION_COOKIE_NAME]
  const signedTokenCookie = cookies[SESSION_COOKIE_SIGNED_TOKEN]
  const userCookie = cookies[SESSION_COOKIE_USER]

  if (!sessionCookie || !signedTokenCookie) {
    return false
  }

  return !!parseInternalUserCookie(userCookie)
}

/**
 * Stale leftovers that can block magic-link login.
 * Does NOT include signedToken-only state (pending same-browser email verification).
 */
export function hasStaleInternalSessionCookies(cookies: CookieMap): boolean {
  return !!(
    cookies[SESSION_COOKIE_NAME] ||
    cookies[SESSION_COOKIE_USER] ||
    cookies[SESSION_COOKIE_CURRENT_TENANT]
  )
}
